module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og nordsamisk_primærlogo_neg(hvit).288795bb.pdf";